import { Controller } from "@hotwired/stimulus"

// Mobile only: the nav links collapse into a dropdown panel opened by the header's hamburger
// button. Tapping any link inside closes it again (same-page anchor links like #plugins don't
// trigger a full Turbo visit, so nothing else would close the panel for those).
export default class extends Controller {
  static targets = ["links", "toggle"]

  toggle() {
    const open = !this.linksTarget.classList.contains("is-open")
    this.linksTarget.classList.toggle("is-open", open)
    this.toggleTarget.setAttribute("aria-expanded", open)
  }

  close() {
    this.linksTarget.classList.remove("is-open")
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }

  linkClicked(event) {
    if (event.target.closest("a, button")) this.close()
  }
}
